import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import BotoneraBottom from '../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

//css
import { ContainerFlexx, Img, BtnColor} from '../../Css/MetodosCSS/StyledLectoEscritura';
import { BtnSilaba } from '../../Css/MetodosCSS/StyledLN3Todos';
import {Flex} from '../../Css/MetodosCSS/StyledCCIntrasilabica';
import { AvanzarBtn, AvanzarImg } from '../../Css/StyledMatematica';

const instrucciones = 'En la pantalla va a aparecer una sílaba. Hay que leerla';
const miniInstrucciones = 'Seleccionar la letra correspondiente al sonido';

const SCR11 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [count, setCount] = useState(1);
    const [indexes, setIndexes] = useState();
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [resultado, setResultado] = useState([]);
    const [contador, setContador] = useState(1);
    const [ejercicioElegido, setEjercicioElegido] = useState();
    const [elegido, setElegido] = useState();

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);

    const play1 = () => {
        new Audio(`/sounds/${comparar.sonido_url_1}.mp3`).play();
        setContador(contador+1);
    }

    const resultadoBase = [
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:""}
    ];

    const verificar = (e) => {
        e.preventDefault();
        if(!elegido) {
            return;
        }
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "0";
            newList[count-1].contador_a = contador;
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setContador(1);
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        if (ejercicioElegido.toUpperCase() !== comparar.palabra_1.toUpperCase()) {
            console.log('mal');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = "0";
            newList[count-1].contador_a = contador;
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setContador(1);
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        } else {
            console.log('bien');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            let puntaje;
            if(contador > 2) {
                puntaje = 1;
            } else {
                puntaje = 2
            }
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = puntaje;
            newList[count-1].contador_a = contador;
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setContador(1);
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('SCR11') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])

    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'tiempo': tiempoFinal,
                    'ejercicio': "SCR11",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} ayuImagen={false} />
            {iniciar
                ?
                    <ContainerFlexx direction="column" height="100%" width="100%">
                        {comparar.ejemplo ? 
                        <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                            Ejemplo
                        </Flex>
                        : null
                        }
                        <ContainerFlexx display="flex" justify="center" align="center" margin="auto">
                            <ContainerFlexx>
                                <Img w="150px" h="200px" src={`/img/nene.png`} />
                            </ContainerFlexx>
                            <ContainerFlexx display="flex" direction="column" justify="center" align="center" >
                                <audio src={`/sounds/${comparar.sonido_url_1}.mp3`} autoPlay />

                                <BtnColor border="none" bg="transparent" 
                                    onClick={() => play1()}
                                >
                                    <Img alt='' w="70px" src={`/img/altavoz.png`} />
                                </BtnColor>
                            </ContainerFlexx>

                            <ContainerFlexx >
                                <BtnSilaba padding="0.5rem 2rem" paddingMob="0.5rem 1rem" font="5rem" style={{border: elegido === "2" ? "black" : null, borderColor: elegido === "2" ? "black" : null, borderStyle: elegido === "2" ? "solid" : null}}
                                    disabled={disable}
                                    onClick={() => (setEjercicioElegido(comparar.palabra_2), setElegido("2"))}
                                >
                                    {comparar.palabra_2}
                                </BtnSilaba>
                                <BtnSilaba padding="0.5rem 2rem" paddingMob="0.5rem 1rem" font="5rem" style={{border: elegido === "3" ? "black" : null, borderColor: elegido === "3" ? "black" : null, borderStyle: elegido === "3" ? "solid" : null}}
                                    disabled={disable}
                                    onClick={() => (setEjercicioElegido(comparar.palabra_3), setElegido("3"))}
                                >
                                    {comparar.palabra_3}
                                </BtnSilaba>
                                <BtnSilaba padding="0.5rem 2rem" paddingMob="0.5rem 1rem" font="5rem" style={{border: elegido === "4" ? "black" : null, borderColor: elegido === "4" ? "black" : null, borderStyle: elegido === "4" ? "solid" : null}}
                                    disabled={disable}
                                    onClick={() => (setEjercicioElegido(comparar.palabra_4), setElegido("4"))}
                                >
                                    {comparar.palabra_4}
                                </BtnSilaba>
                            </ContainerFlexx>
                        </ContainerFlexx>
                        <ContainerFlexx margin="0 0rem 0 0rem" width="90%" justify="space-between" display="flex" align="center">
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                            <AvanzarBtn
                                disabled={disable}
                                onClick={(e) => (verificar(e), setElegido(''))}
                            >
                                <AvanzarImg src={'/img/play.png'} /> 
                            </AvanzarBtn>
                        </ContainerFlexx>
                    </ContainerFlexx>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}

export default SCR11;